import React from "react";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/pasteur.run/";

export default function CtaSection() {
  return (
    <section data-testid="cta-section" className="px-4 sm:px-6 pb-8 max-w-7xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="inline-block px-8 sm:px-12 py-8 sm:py-10"
      >
        <div className="gold-line w-24 mx-auto mb-8" />

        <h3 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F0F10] mb-3">
          Se parte de esta historia
        </h3>

        <p className="font-body text-sm sm:text-base text-[#6B7280] max-w-md mx-auto mb-8">
          Celebra 100 años de excelencia en salud corriendo junto a nosotros.
          Inscríbete ahora y forma parte de este evento histórico.
        </p>

        <a
          data-testid="cta-inscribirse-btn"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 bg-[#0F0F10] text-white rounded-full px-5 py-2.5 shadow-lg hover:shadow-[0_10px_30px_rgba(0,0,0,0.3)] transition-all duration-500 hover:scale-[1.03] font-body font-medium text-sm"
        >
          <Instagram className="w-4 h-4" />
          Siguenos
        </a>
      </motion.div>
    </section>
  );
}
